import * as TabsPrimitive from '@radix-ui/react-tabs';
import type { ComponentProps, JSX } from 'react';
import { cn } from '@/lib/utils';

export const Tabs = TabsPrimitive.Root;

export function TabsList({ className, ...props }: ComponentProps<typeof TabsPrimitive.List>): JSX.Element {
  return (
    <TabsPrimitive.List
      data-slot="tabs-list"
      className={cn('inline-flex data-[orientation=vertical]:flex-col data-[orientation=vertical]:items-stretch data-[orientation=horizontal]:items-center gap-1', className)}
      {...props}
    />
  );
}

export function TabsTrigger({ className, ...props }: ComponentProps<typeof TabsPrimitive.Trigger>): JSX.Element {
  return (
    <TabsPrimitive.Trigger
      data-slot="tabs-trigger"
      className={cn(
        'inline-flex items-center justify-start whitespace-normal text-left rounded-md px-3 py-2 text-sm font-medium transition-colors outline-none',
        'text-muted-foreground hover:text-foreground hover:bg-accent',
        'data-[state=active]:bg-hce-pine/10 data-[state=active]:text-hce-pine data-[state=active]:font-semibold',
        'focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}

export function TabsContent({ className, ...props }: ComponentProps<typeof TabsPrimitive.Content>): JSX.Element {
  return <TabsPrimitive.Content data-slot="tabs-content" className={cn('outline-none', className)} {...props} />;
}
